import { createGlobalStyle, css } from 'styled-components';

export default createGlobalStyle`
  ${({ theme: { spacing, font, color, border } }) => css`
    * {
      margin: ${spacing.km0};
      padding: ${spacing.km0};
      font-family: ${font.family.body};
      font-weight: ${font.weight.regular};
      font-size: ${font.size.base};
      box-sizing: border-box;
    }

    body,
    html,
    #root {
      height: 100%;
    }

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      background-color: ${color.icon.neutral.weak}6e;
      -webkit-border-radius: ${border.radius.small};
      border-radius: ${border?.radius.small};
    }

    ::-webkit-scrollbar-thumb {
      -webkit-border-radius: ${border.radius.small};
      border-radius: ${border.radius.small};
      background-color: ${color.icon.neutral.weak};
    }

    ::-webkit-scrollbar-thumb:window-inactive {
      background-color: ${color.icon.neutral.weak}6e;
    }

    /* CSS hack for Firefox  */
    :root {
      scrollbar-color: rgb(186, 190, 201, 1) rgb(186, 190, 201, 0.5) !important;
      scrollbar-width: 2em !important;
    }
  `}
`;
